import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { GetHook } from "../../../../api/api";
import { PERIOD_URL, SCORECARD_URL } from "../../../../api/urls";
import { OrganisationTypeIcon } from "../../../../assets/svg/OrganisationTypeIcon";
import { ScorecardIcon } from "../../../../assets/svg/ScorecardIcon";
import { SettingsIcon } from "../../../../assets/svg/SettingsIcon";
import { Button } from "../../../../ui/Button";
import { TitleText } from "../../../../ui/Text";
import { get } from "../../../../utils/get";
import axios from "../../../../utils/axios";
import PeformanceContract from "./PeformanceContract";
import Preview from "./Preview";

interface PreviewProps {
  scorecardId: string;
  closeModal: any;
  initialStep?: number;
}

const PreviewContainer = ({
  scorecardId,
  closeModal,
  initialStep,
}: PreviewProps) => {
  const [step, setStep] = useState(1);
  const [url, setUrl] = useState("");
  const { data: scorecard } = GetHook(`${SCORECARD_URL}/${scorecardId}/summary`);

  const previewRef = useRef<any>();
  const nextStep = () => {
    setStep(step + 1);
  };
  const previousStep = () => {
    setStep(step - 1);
  };


  useEffect(() => {
    if (initialStep) {
      setStep(initialStep);
    }
    return () => {};
  }, [initialStep]);

  useEffect(() => {
    if (scorecard[0]?.period_id) {
      axios.get(`${PERIOD_URL}/${scorecard[0]?.period_id}`).then((res) => {
        const { returned_resultset } = res?.data;
        setUrl(returned_resultset[0].url);
      });
    }
    return () => {};
  }, [scorecard]);

  const renderSteps = () => {
    switch (step) {
      case 1:
        return (
          <Preview
            scorecard={scorecard}
            scorecardId={scorecardId}
            closeModal={closeModal}
          />
        );
      case 2:
        return <PeformanceContract url={url} />;
    }
  };

  return (
    <Container>
      <div style={{ display: "flex", alignItems: "center" }}>
        <TitleText>Balanced Scorecard</TitleText>
        <Button
          text="X"
          style={{ marginLeft: "auto" }}
          onClick={() => closeModal()}
        />
      </div>

      <DetailHeader>
        <TitleText style={{ fontSize: 18 }}>
          {get(scorecard, "[0]owner")}
        </TitleText>
        <TitleText style={{ fontWeight: 400, fontSize: 16 }}>
          {get(scorecard, "[0]owner.job_title", "")}
        </TitleText>{" "}
        <TitleText style={{ fontWeight: 400, fontSize: 14 }}>
          {get(scorecard, "[0]period_name", "")}
        </TitleText>{" "}
        <TitleText
          style={{
            fontSize: "18px",
            display: "flex",
            flexDirection: "column",
            alignItems: "baseline",
            lineHeight: 1,
          }}
        >
          {/* {get(scorecard, "[0]name")} */}
          <span style={{ fontSize: 14, fontWeight: 300, color: "gray" }}>
            {" "}
            {get(scorecard, "[0]status")}
          </span>
        </TitleText>
      </DetailHeader>

      <Header>
        <HeaderItem
          onClick={() => previousStep()}
          enabled={step === 1 ? true : false}
        >
          <ScorecardIcon isActive />
          <TitleText>Scorecard Preview</TitleText>
        </HeaderItem>
        <HeaderItem
          onClick={() => nextStep()}
          enabled={step === 2 ? true : false}
        >
          <OrganisationTypeIcon isActive />
          <TitleText>Performance Contract</TitleText>
        </HeaderItem>
      </Header>
      {renderSteps()}
    </Container>
  );
};

export default PreviewContainer;
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  border: 2px solid rgba(76, 92, 251, 0.1);
  border-radius: 1em;
  margin-top: 1em;
  margin-bottom: 1em;
`;

const DetailHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 1em;
  border-bottom: 1px solid #ccc;
  ${TitleText} {
    margin-right: 16em;
  }
`;

const HeaderItem = styled.button<{ enabled: boolean }>`
  display: flex;
  font-size: 12;
  font-weight: 600;
  align-items: center;
  background-color: ${(props) => (props.enabled ? "#EBEFFF" : "#fff")};
  color: #01A8CE;
  padding: 1em 1.5em 1em 1.5em;
  border-radius: 1em;
  width: 100%;
  cursor: pointer;
  box-shadow: 0px 0px 0px transparent;
  border: 0px solid transparent;
  text-shadow: 0px 0px 0px transparent;
  opacity: ${(props) => (props.enabled ? 1 : 0.4)};
  ${TitleText} {
    padding-left: 1em;
    color: #01A8CE;
    font-size: 12px;
  }
  &:focus {
    outline: none;
  }
`;
